var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRouteOptimize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10527 10.918L4.60746 10.9221C4.27224 10.9221 3.95616 10.7914 3.72014 10.5547C3.48274 10.318 3.35207 10.0026 3.35207 9.66808V8.98599C3.35207 8.29433 3.91443 7.73197 4.60678 7.73197H8.80809C10.0607 7.73197 11.0835 6.71261 11.089 5.45998L11.0924 4.76832C11.0952 4.15602 10.8584 3.58066 10.4261 3.14829C9.99575 2.71659 9.42244 2.47852 8.81014 2.47852H8.80467L7.09569 2.48878C6.81246 2.49083 6.58464 2.72138 6.58601 3.00462C6.58738 3.28717 6.81725 3.51498 7.09911 3.51498H7.10254L8.80946 3.50472H8.81219C9.14742 3.50472 9.46281 3.63539 9.7002 3.87279C9.9376 4.11155 10.0676 4.42762 10.0662 4.76353L10.0628 5.45588C10.0601 6.14478 9.49701 6.70577 8.80809 6.70577H4.60678C3.34934 6.70577 2.32587 7.72855 2.32587 8.98599V9.66808C2.32587 10.277 2.56258 10.8496 2.99427 11.2806C3.42527 11.7109 3.9979 11.9483 4.60746 11.9483H4.60883L7.10596 11.9442C7.38919 11.9435 7.61906 11.7136 7.61837 11.4304C7.61769 11.1472 7.3885 10.918 7.10527 10.918Z",
    fill: "url(#paint0_linear_1436_18524)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42223 3.12026C3.14174 3.12026 2.90913 2.90134 2.90913 2.62085V2.60032C2.90913 2.31298 3.14174 2.08722 3.42223 2.08722C3.70957 2.08722 3.93533 2.31298 3.93533 2.60032C3.93533 2.88082 3.70957 3.12026 3.42223 3.12026ZM3.42223 5.46001C3.97638 5.46001 5.56358 4.00964 5.56358 2.614C5.56358 1.43045 4.60579 0.472656 3.42223 0.472656C2.23867 0.472656 1.28088 1.43045 1.28088 2.614C1.28088 4.00964 2.86808 5.46001 3.42223 5.46001Z",
    fill: "url(#paint1_linear_1436_18524)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.579 11.1388C10.2985 11.1388 10.0659 10.9199 10.0659 10.6326V10.612C10.0659 10.3315 10.2985 10.0989 10.579 10.0989C10.8595 10.0989 11.0921 10.3315 11.0921 10.612C11.0921 10.8925 10.8595 11.1388 10.579 11.1388ZM10.579 8.48438C9.40232 8.48438 8.43768 9.44901 8.43768 10.6257C8.43768 12.0282 10.0317 13.4717 10.579 13.4717C11.1332 13.4717 12.7204 12.0282 12.7204 10.6257C12.7204 9.44901 11.7626 8.48438 10.579 8.48438Z",
    fill: "url(#paint2_linear_1436_18524)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1436_18524",
    x1: 2.32587,
    y1: 2.47852,
    x2: 2.32587,
    y2: 11.9483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1436_18524",
    x1: 1.28088,
    y1: 0.472656,
    x2: 1.28088,
    y2: 5.46001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1436_18524",
    x1: 8.43768,
    y1: 8.48438,
    x2: 8.43768,
    y2: 13.4717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteOptimize);
export default __webpack_public_path__ + "static/media/route_optimize.e92d5bbd.svg";
export { ForwardRef as ReactComponent };